import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Storage } from 'aws-amplify';

function ViewFile({ messageData }) {
    const [fileData, setFileData] = useState({ fileName: '', url: '' });

    useEffect(() => {
        const fetchFileUrl = async () => {
            if (!messageData?.content) return;

            try {
                const key = messageData.content.replace(/^public\//, '');
                const url = await Storage.get(key);

                const fileName = messageData.fileName || key.split('/').pop();

                setFileData({ fileName, url });

            } catch (err) {
                console.error('getFileNameFromUrl err:', err);
            }
        };

        fetchFileUrl();
    }, [messageData]);

    if (!messageData?.content) return null;

    return (
        <div className='ai-message-text'>
            <a href={fileData.url} target="_blank" rel="noopener noreferrer">
                {fileData.fileName || 'Download File'}
            </a>
        </div>
    );
}

ViewFile.propTypes = {
    message: PropTypes.any
};

export default ViewFile;
